module.exports = __webpack_public_path__ + "img/banner2.f077a322.jpeg";